export default {
      id: "flex-alignContent-stretch-usage",
      viewBox: "0 0 40 40",
      url: "assets/" + "sprite.svg#flex-alignContent-stretch-usage",
      toString: function () {
        return this.url;
      }
    }